import { render, staticRenderFns } from "./select-mulu.vue?vue&type=template&id=54cba76c&scoped=true&"
import script from "./select-mulu.vue?vue&type=script&lang=ts&"
export * from "./select-mulu.vue?vue&type=script&lang=ts&"
import style0 from "./select-mulu.vue?vue&type=style&index=0&id=54cba76c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cba76c",
  null
  
)

export default component.exports